import RatingComponent from "lib/components/Rating"
import Text from "lib/components/Text"
import { roundValueRating } from "lib/helpers"

export default function CardStars({ totalRating, averageRating }) {
  return (
    <>
      {averageRating > 0 && (
        <div className="flex flex-row space-x-2 items-center mt-4">
          <Text color="muted" size="small">
            {averageRating === 0
              ? averageRating
              : roundValueRating(parseFloat(averageRating).toFixed(1))}
          </Text>

          <RatingComponent
            size={13}
            count={5}
            isHalf
            value={roundValueRating(parseFloat(averageRating).toFixed(1))}
          />
          <Text size="small" color="gray">
            {`(${
              totalRating?.length > 100
                ? `${Math.round(totalRating)}+ Ratings`
                : `${Math.round(totalRating)} Rating${Math.round(totalRating) > 1 ? "s" : ""}`
            })`}
          </Text>
        </div>
      )}
    </>
  )
}
